import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Typography, Button, Flex } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { fetchAccountsList } from "./accountsThunks";
import AccountList from "./components/AccountList";

const { Title } = Typography;

const Accounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accounts } = useSelector((state) => state.accounts);

  useEffect(() => {
    dispatch(fetchAccountsList());
  }, [dispatch]);

  return (
    <>
      <Flex align="center" gap={8}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="accounts-back-button"
        />
        <Title level={2} style={{ margin: 0 }}>Chart of Accounts</Title>
      </Flex>
      <AccountList accountsList={accounts} />
    </>
  );
};

export default Accounts;
